import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  HeaderType,
  HeaderTab,
  HeaderTypeRequest,
} from '../interfaces/header.interface';
import { SessionHeaderEventType } from '../enums/session-header-event-type.enum';
import { NotificationEventType } from '../enums/notification-event-type.enum';

@Injectable()
export class AppService {
  private headerState$ = new BehaviorSubject<HeaderTypeRequest>({
    type: HeaderType.DEFAULT,
  });
  private headerEvents$ = new Subject<SessionHeaderEventType>();
  private headerTabs$ = new Subject<any>();
  private dropHeaderTabs$ = new Subject<any>();
  private archiveData$ = new Subject<any>();
  private headerEventNavigate$ = new Subject<HeaderTab>();
  private notifications$ = new Subject<any>();

  changeHeaderState(data: HeaderTypeRequest) {
    this.headerState$.next(data);
  }
  getHeaderState() {
    return this.headerState$.asObservable();
  }
  sendNotification(data: NotificationEventType) {
    this.notifications$.next(data);
  }
  getNotification() {
    return this.notifications$.asObservable();
  }
  setCurrentScenario(id: number) {
    this.notifications$.next(id);
  }
  getCurrentScenario() {
    return this.notifications$.asObservable();
  }
  setHeaderEvent(data: SessionHeaderEventType) {
    this.headerEvents$.next(data);
  }
  getHeaderEvents() {
    return this.headerEvents$.asObservable();
  }

  setNavigateEvent(event: HeaderTab) {
    this.headerEventNavigate$.next(event);
  }
  getNavigateEvents() {
    return this.headerEventNavigate$.asObservable();
  }

  setHeaderTab(data) {
    this.headerTabs$.next(data);
  }
  getHeaderTabs() {
    return this.headerTabs$.asObservable();
  }
  dropScenario(data) {
    this.dropHeaderTabs$.next(data);
  }
  getDropedScenario() {
    return this.dropHeaderTabs$.asObservable();
  }

  setArchiveData(data) {
    this.archiveData$.next(data);
  }
  getArchiveData() {
    return this.archiveData$.asObservable();
  }
}
